import Tdg_MapItemListResultModelBase from '../_generated/modelBases/tdg-map-item-list-result-model-base';

export default class Tdg_MapItemListResultModel extends Tdg_MapItemListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
